export const groupBy = (_array: any[], sortBy: string) =>
  _array.length > 0 &&
  // eslint-disable-next-line unicorn/prefer-object-from-entries,unicorn/no-array-reduce
  _array.reduce((previous, current) => {
    const type = current[sortBy];
    previous[type] = previous[type] ?? [];
    previous[type].push(current);
    return previous;
  }, {});
